import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";
import { api, errMsg } from "@/lib/api";
import { Check } from "lucide-react";

const FIELDS = [
  ["first_name", "firstName"], ["last_name", "lastName"], ["email", "email"],
  ["phone", "phone"], ["company", "company"], ["country", "country"], ["city", "city"],
];

export const RegisterDialog = ({ open, onOpenChange }) => {
  const { t } = useApp();
  const [form, setForm] = useState({});
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/registrations", form);
      setDone(true);
      setForm({});
    } catch (er) { setError(errMsg(er)); }
    setBusy(false);
  };

  const close = (v) => { onOpenChange(v); if (!v) setTimeout(() => setDone(false), 200); };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent data-testid="register-dialog" aria-describedby={undefined}
        className="bg-[#0a0a0a] border border-white/10 max-w-lg p-0 overflow-hidden">
        <div className="px-8 pt-8 pb-3">
          <p className="overline">BEDAS</p>
          <DialogHeader>
            <DialogTitle className="font-serif text-3xl font-light text-white mt-2">
              {done ? t("thanks") : t("registerTitle")}
            </DialogTitle>
          </DialogHeader>
        </div>

        {done ? (
          <div data-testid="register-success" className="px-8 pb-10 pt-2 flex flex-col items-start gap-5">
            <div className="w-12 h-12 border border-gold/50 flex items-center justify-center">
              <Check className="text-gold" size={20} />
            </div>
            <p className="text-sm text-neutral-400 leading-relaxed">{t("thanks")}.</p>
            <button data-testid="register-close-btn" onClick={() => close(false)}
              className="border border-white/20 px-6 py-2.5 text-[0.7rem] uppercase tracking-[0.2em] text-neutral-200 hover:bg-white/10 transition-colors duration-300">
              {t("close")}
            </button>
          </div>
        ) : (
          <form onSubmit={submit} className="px-8 pb-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {FIELDS.map(([name, label]) => (
              <div key={name} className={name === "email" || name === "company" ? "sm:col-span-2" : ""}>
                <label className="block text-[0.65rem] uppercase tracking-[0.2em] text-neutral-500 mb-2">{t(label)}</label>
                <input required data-testid={`register-${name}`} name={name}
                  type={name === "email" ? "email" : "text"}
                  value={form[name] || ""}
                  onChange={(e) => setForm({ ...form, [name]: e.target.value })}
                  className="w-full bg-[#131313] border border-white/10 px-3 py-2.5 text-sm text-white outline-none focus:border-gold transition-colors duration-300" />
              </div>
            ))}
            {error && <p data-testid="register-error" className="sm:col-span-2 text-xs text-red-400">{error}</p>}
            <button type="submit" disabled={busy} data-testid="register-submit-btn"
              className="sm:col-span-2 mt-2 bg-gold text-black py-3 text-[0.72rem] uppercase tracking-[0.24em] font-medium hover:bg-white transition-colors duration-300 disabled:opacity-50">
              {busy ? "..." : t("submit")}
            </button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default RegisterDialog;
